
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const UltrasoundFacial = () => {
  const treatmentData = {
    title: "Ultrasound Facial",
    subtitle: "Non-invasive skin tightening with ultrasound technology",
    description: "Our ultrasound facial uses focused ultrasound energy to stimulate collagen production deep within the skin, providing natural lifting and tightening effects without surgery.",
    whoItsFor: [
      "Those with mild to moderate skin laxity",
      "People wanting non-surgical lifting",
      "Anyone seeking preventative anti-aging",
      "Clients with fine lines and wrinkles",
      "Those wanting gradual, natural results"
    ],
    packages: [
      {
        name: "Face Ultrasound",
        visitorPrice: "$800",
        memberPrice: "$720",
        description: "Full face ultrasound treatment for lifting and tightening"
      },
      {
        name: "Face & Neck Package",
        visitorPrice: "$1,200",
        memberPrice: "$1,080",
        description: "Comprehensive treatment for face and neck area"
      },
      {
        name: "Maintenance Series",
        visitorPrice: "$2,100",
        memberPrice: "$1,890",
        description: "Package of 3 treatments for optimal long-term results"
      }
    ],
    beforeCare: [
      "Avoid retinoids 3 days prior",
      "Stay well hydrated",
      "Come with clean, makeup-free skin",
      "Avoid anti-inflammatory medications"
    ],
    duringCare: [
      "Ultrasound gel application",
      "Precise energy delivery to targeted depths",
      "60-90 minute treatment time",
      "Real-time monitoring for safety"
    ],
    afterCare: [
      "Gentle skincare for 24 hours",
      "Avoid extreme temperatures",
      "Stay hydrated",
      "Results develop over 2-3 months"
    ],
    memberPerks: [
      "10% discount on ultrasound treatments",
      "Complimentary consultation and skin analysis",
      "Free follow-up assessment at 3 months",
      "Priority booking for maintenance treatments",
      "Access to professional anti-aging products"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default UltrasoundFacial;
